import React from 'react';
import {Spin} from 'antd';
import {observer} from 'mobx-react';
import MyBreadcrumb from '@components/MyBreadcrumb/MyBreadcrumb'
import global_store from '@store/Common/GlobalStore';

const side_padding = '24px';

@observer
class ListPageLayout extends React.Component {
    render() {

        let header_container_style = {
            padding: `14px ${side_padding}`,
            background: '#fff'
        };

        let list_container_style = {
            padding: '14px 24px'
        };

        let headerNormalStyle = {flex: 1};
        if (this.props.isCustomHeader) {
            headerNormalStyle = {}
        }

        let bread_crumb_style = {
            ...headerNormalStyle,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            maxWidth: '600px'
        };

        let page_header_style = {
            display: 'flex',
            flexDirection: 'row',
            background: '#fff'
        };
        return (
            <div>
                <Spin spinning={global_store.is_loading} size="large">
                    <div style={header_container_style}>
                        {/*<div>*/}
                        {/*<MyBreadcrumb/>*/}
                        {/*</div>*/}
                        <div style={page_header_style}>
                            {
                                this.props.hideBreadcrumb ? null : (
                                    <div style={bread_crumb_style}>
                                        <MyBreadcrumb/>
                                    </div>
                                )
                            }
                            {
                                this.props.header
                            }
                        </div>
                    </div>
                    <div style={list_container_style}>
                        {
                            this.props.addNew ? this.props.addNew : null
                        }
                        <div>
                            {
                                this.props.list
                            }
                        </div>
                    </div>
                    {
                        this.props.edit
                    }
                    {
                        this.props.modal
                    }
                </Spin>
            </div>
        );
    }
}

export default ListPageLayout;



// WEBPACK FOOTER //
// ./src/layouts/ListPageLayout.jsx